/* eslint-disable import/named */
import { AxiosResponse } from 'axios';
import api from './api';
import {
  Response, Categoria, Solicitacao,
} from '../pages/models';

export async function getCategorias():Promise<Response<Categoria[]>> {
  const response: AxiosResponse<Response<Categoria[]>> = await api.get('Solicitacao/Categorias');
  const rr = new Response<Categoria[]>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function getHistorico():Promise<Response<Solicitacao[]>> {
  const response: AxiosResponse<Response<Solicitacao[]>> = await api.get('Solicitacao/GetHistoricos');
  const rr = new Response<Solicitacao[]>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function getNotificacoes():Promise<Response<string[]>> {
  const response: AxiosResponse<Response<string[]>> = await api.get('Solicitacao/GetNotificacoesAcompanhamentoSolicitacao');
  const rr = new Response<string[]>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function putNotificacoes(array: string[]):Promise<Response<any>> {
  const response: AxiosResponse<Response<any>> = await api.put('Solicitacao/VisualizouNotificacoesAcompanhamentos', array);
  const rr = new Response<any>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function postSolicitacao(solicitacao: any):Promise<Response<any>> {
  const response: AxiosResponse<Response<any>> = await api.post('Solicitacao/NovaSolicitacao', solicitacao);
  const rr = new Response<any>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function putSolicitacao(solicitacao: any):Promise<Response<any>> {
  const response: AxiosResponse<Response<any>> = await api.put('Solicitacao/AlterarSolicitacao', solicitacao);
  const rr = new Response<any>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function deleteSolicitacao(id: any):Promise<Response<any>> {
  const response: AxiosResponse<Response<any>> = await api.delete(`Solicitacao/DeletarSolicitacao/${id}`);
  const rr = new Response<any>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};

export async function getSolicitacao(id: string):Promise<Response<Solicitacao>> {
  const response: AxiosResponse<Response<Solicitacao>> = await api.get(`Solicitacao/GetSolicitacao/${id}`);
  const rr = new Response<Solicitacao>();
  if (response.status === 200) {
    rr.sucesso = response.data.sucesso;
    rr.dados = response.data.dados;
    rr.erros = response.data.erros;
  } else {
    rr.sucesso = false;
    rr.erros = [{ propertyName: 'Conexão', errorMessage: 'erro de conexão' }];
  }
  return rr;
};
